export default __webpack_public_path__ + "static/media/sticker-education-128@2x.24074a48.png";